"use client"

import React from 'react'
import { DefaultValues, FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import InputWithToggle from '../components/input-with-toggle'
import { NotificationSettingsFormType } from '../schemas/setting-notifications-form.schema'
import { notificationSettingsFormSchema } from '../schemas/setting-notifications-form.schema'
import ProfileUpdateButton from '../../profile/components/profile-update-button'
import { updateNotifications } from '../actions/settings.action'
import successToast from '@/shared/lib/toast/success.toast'
import errorToast from '@/shared/lib/toast/error.toast'



type SettingNotificationsFormProps = {
    defaultValues: DefaultValues<NotificationSettingsFormType>
}

function SettingNotificationsForm({defaultValues}: SettingNotificationsFormProps) {
    
    const form = useForm<NotificationSettingsFormType>({
        resolver: zodResolver(notificationSettingsFormSchema),
        defaultValues,
    })

    const { formState: { isSubmitting, isDirty }, setValue, handleSubmit, control } = form

    const onSubmit = async (data: NotificationSettingsFormType) => {
        const res = await updateNotifications(data)
        if(!res.success) {
            errorToast(res.message)
            return
        }
        successToast("Notifications updated successfully")
        form.reset(data)
    }

    return (
        <FormProvider {...form}>
            <form 
                onSubmit={handleSubmit(onSubmit)}
                className='flex flex-col gap-5'
            >
                <InputWithToggle
                    title='Chat message notifications'
                    description="Receive texts based on your sender' s settings"
                    name="chatNotifications"
                    control={control}
                />
                <InputWithToggle
                    title='Receive work order notifications'
                    description="Receive texts based on your sender' s settings"
                    name="workOrderNotifications"
                    control={control}
                />
                <ProfileUpdateButton 
                    disabled={!isDirty || isSubmitting}
                    showLoader={isSubmitting}
                    className='self-end'
                >
                    Update Notifications
                </ProfileUpdateButton>
            </form>
        </FormProvider>
    )
}

export default SettingNotificationsForm